import React, { useEffect, useState } from 'react';
import { GradientDiv } from './components/GradientDiv/GradientDiv';
import NavigationBar from './components/NavigationBar/NavigationBar';
import styles from './App.module.css';
import { createClient } from 'contentful';
import { Item } from './types';
import Experience from './components/Experience/Experience';
import Projects from './components/Projects/Projects';
import ScrollProgressBar from './components/ScrollProgressBar/ScrollProgressBar';
import LoadingSpinner from './components/LoadingSpinner/LoadingSpinner';
import Footer from './components/Footer/Footer';

export type Section = 'experience' | 'projects' | '';

function App() {
  const pageIDs: Section[] = ['experience', 'projects'];

  const [experience, setExperience] = useState<Item[]>([]);
  const [projects, setProjects] = useState<Item[]>([]);

  const [isLoading, setIsLoading] = useState(false);

  const client = createClient({
    space: `${process.env.REACT_APP_CONTENTFUL_SPACE_ID}`,
    accessToken: `${process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN}`,
  });

  useEffect(() => {
    const getData = async () => {
      setIsLoading(true);

      const res: any = await client.getEntries();
      if (!res) {
        // error
        return;
      }

      const exp: Item[] = [];
      const proj: Item[] = [];

      res.items.forEach((item: any) => {
        if (item.sys.contentType?.sys.id === 'experience') {
          exp.push(item);
        } else {
          proj.push(item);
        }
      });

      setExperience(exp);
      setProjects(proj);

      setIsLoading(false);
    };
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading) {
    return (
      <GradientDiv>
        <LoadingSpinner />
      </GradientDiv>
    );
  }

  return (
    <GradientDiv>
      <NavigationBar pageIDs={pageIDs} />

      <div className={styles.container}>
        <ScrollProgressBar />

        <div style={{ height: 250 }} />

        {pageIDs.map((page) =>
          page === 'experience' ? (
            <section
              className={`${styles.section} ${styles.exp}`}
              id={page}
              key={page}
            >
              <Experience experience={experience} />
            </section>
          ) : (
            <section className={styles.section} id={page} key={page}>
              <Projects projects={projects} />
            </section>
          )
        )}
      </div>

      <Footer />
    </GradientDiv>
  );
}

export default App;
